/**
 * REQ-60 数値の入力欄 (`<input type="number">`) の上でホイールを回しても、**値を変えない**。
 *
 * ブラウザ (Chrome 等) は、フォーカスのある数値の入力欄の上でホイールを回すと値を増減させる。
 * 返金額を入れたあと、下の「返金を実行」までホイールで動かすと、気付かないうちに額が変わっていた
 * (モーダルの背景をスクロールできるようにした REQ-60 で、その操作が起きやすくなった)。
 * 数値の入力欄はアプリ全体で 60 か所を超え、金額の欄も多いので、1 つずつではなくここでまとめて受ける。
 *
 * ホイールが来たら入力欄のフォーカスを外すだけにする。値は変わらず、ホイールはそのまま
 * 画面 (モーダル) のスクロールになる。止めない (preventDefault しない) ので passive で張れる。
 * タッチの端末にはホイールが無いので、何も変わらない。
 */
function onWheel(e: WheelEvent) {
  const el = e.target
  if (el instanceof HTMLInputElement && el.type === 'number' && el === document.activeElement) el.blur()
}

if (typeof document !== 'undefined') {
  document.addEventListener('wheel', onWheel, { capture: true, passive: true })
}
